import React from "react";

import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";

import { useApiErrorActionsContext } from "commons/context/apiError";

import { StateApiErrorType } from "commons/hooks/useNavigateToApiErrorPage";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import LinkButton from "components/ui/LinkButton";

type PropsType = {
    readonly state: StateApiErrorType;
    readonly reloadPage?: boolean;
};

function DisplayApiError({ state, reloadPage }: PropsType) {
    const navigate = useNavigate();

    const apiErrorActions = useApiErrorActionsContext();

    const backToDashboardClick = React.useCallback(() => {
        if (apiErrorActions !== undefined) {
            apiErrorActions.hideError();
        }
    }, [apiErrorActions]);

    const onReloadPageClick = React.useCallback(() => navigate(0), [navigate]);

    return (
        <GridColumn>
            <GridItem>
                <GridRow justifyContent={"center"}>
                    <GridItem className={"col-xs-auto"} style={{ textAlign: "center" }}>
                        <h1>Errore tecnico</h1>

                        <p>{`${state.method} ${state.url}`}</p>
                        <p>{`Status code: ${state.status}`}</p>
                        <p>{`Identificativo errore per assistenza: ${state.xRequestId}`}</p>
                    </GridItem>
                </GridRow>
            </GridItem>

            <GridItem>
                {reloadPage && (
                    <GridRow justifyContent={"center"}>
                        <GridItem className={"col-xs-auto"}>
                            <Button
                                variant={"contained"}
                                color={"primary"}
                                onClick={onReloadPageClick}
                            >
                                {"Ricarica"}
                            </Button>
                        </GridItem>
                    </GridRow>
                )}

                {!reloadPage && (
                    <GridRow justifyContent={"center"}>
                        <GridItem className={"col-xs-auto"}>
                            <LinkButton
                                to={"/dashboard"}
                                onClick={backToDashboardClick}
                                label={"Ritorna alla dashboard"}
                            />
                        </GridItem>
                    </GridRow>
                )}
            </GridItem>
        </GridColumn>
    );
}

export default DisplayApiError;
